import moment from 'moment'

export function createWeekDays(startDateString, endDateString, jobDays) {

    let list = []

    // get all of the dates
    const startDate = moment(startDateString)
    let currentDate = startDate.clone()
    const maxIterations = 14
    let currentIteration = 0
    while(currentDate.format("YYYY-MM-DD") !== moment(endDateString).add(1, 'day').format("YYYY-MM-DD") && currentIteration < maxIterations) {

        let weekDayItem = {jobDays: []}
        // get the week day
        weekDayItem['label'] = currentDate.format("dddd")

        // date number
        weekDayItem['number'] = currentDate.format("DD")

        // get all job days for that date
        jobDays.forEach(jobDay => {
            if(moment(jobDay.date).format("YYYY-MM-DD") == currentDate.format("YYYY-MM-DD")) {
                weekDayItem.jobDays.push({
                    id: jobDay.id,
                    title: jobDay.job.name,
                    time: `${moment(`${jobDay.date} ${jobDay.startTime}`).format("h:mm A")} - ${moment(`${jobDay.date} ${jobDay.endTime}`).isValid() ? moment(`${jobDay.date} ${jobDay.endTime}`).format("h:mm A") : ""}`
                })
            }
        })
        
        // iterate and add to the list
        currentIteration++
        currentDate.add(1, 'day')
        list.push(weekDayItem)
    }

    return list
}